import App from 'next/app';
import Head from 'next/head';
import React from 'react';
import { Provider } from 'react-redux';
import withRedux from 'next-redux-wrapper';
import withReduxSaga from 'next-redux-saga';

import { TOKEN_VALIDATION_STATE } from '../common/utils/jwt';
import createStore from '../common/store';
import withAuth from '../common/providers/withAuth';

import '../project/polyfill';


let initialRender = false;

class MyApp extends App {
    static async getInitialProps({ Component, ctx }) {
        let pageProps;
        if (ctx.pathname === '/_error') {
            return;
        }

        if (!ctx.pathname) {
            return;
        }
        const locale = Constants.simulate.FORCE_LANGUAGE || API.getStoredLocale(ctx.req); // Retrieve the locale from cookie or headers

        if (Component.getInitialProps) { // Wait for pages to complete any async getInitialProps
            pageProps = await Component.getInitialProps({ ctx });
        }
        return { pageProps, locale };
    }

    componentDidMount () {
        if ((typeof window !== 'undefined') && !this.props.store.getState().clientLoaded) {
            this.authCognitoUser();
        }
    }

    authCognitoUser = async () => {
        const { dispatch } = this.props.store;

        let userObject = null;
        const cognitoState = await API.authCognitoUser();

        if (cognitoState) {
            const { tokenState, idToken } = cognitoState;
            dispatch(AppActions.userLoading(true));

            if (tokenState === TOKEN_VALIDATION_STATE.Valid) {
                userObject = {
                    token: idToken,
                };

                this.props.loginWithToken(idToken, {
                    onSuccess: (res) => {
                        API.identify(res.id);
                    },
                    onError: (e) => {
                        console.log(e);
                    },
                });
            }
        }

        dispatch(AppActions.userLoading(false));
        dispatch(AppActions.startup({
            locale: this.props.locale,
            user: userObject,
            clientLoaded: true,
        }, { onSuccess: () => {} }));
    }

    render() {
        const { Component, pageProps, store } = this.props;

        if (!initialRender) { // Ensure we set the locale before rendering anything
            initialRender = true;
            const locale = store.getState().locale;
            if (locale) {
                Strings.setLanguage(locale);
            }
        }

        return (
            <Provider store={store}>
                <React.Fragment>
                    <Head>
                        <meta charSet="utf-8"/>
                        <meta httpEquiv="x-ua-compatible" content="ie=edge"/>
                        <meta name="description" content="Get the best price on your EvolveYou subscription. Start your 7 Day Free Trial and try home & gym workout programs and nutrition plans."/>
                        <meta name="theme-color" content="#317EFB"/>
                        <meta name="viewport" content="width=device-width, initial-scale=1, shrink-to-fit=no"/>
                        <link rel="apple-touch-icon" href="/static/images/icons-192.png"/>
                        <link rel="icon" sizes="192x192" href="/static/images/icons-192.png"/>
                        {/* <link rel="manifest" href="/static/manifest.json"/> */}
                        <link rel="shortcut icon" href="/static/images/favicon.ico"/>
                        <link
                          rel="icon" type="image/png" sizes="32x32"
                          href="/static/images/favicon-32x32.png"
                            />
                        <link
                          rel="icon" type="image/png" sizes="16x16"
                          href="/static/images/favicon-16x16.png"
                            />
                        <meta property="og:title" content="Join EvolveYou" />
                        <meta property="og:type" content="website" />
                        <meta property="og:url" content="https://join.evolveyou.app" />
                        <meta property="og:image" content="/static/images/tone-and-sculpt.jpg" />
                        <title>7 Day Free Trials & Prices | EvolveYou</title>
                        <script src="https://js.chargebee.com/v2/chargebee.js" />
                        <script src="https://js.stripe.com/v2/"></script>
                        <script src="https://js.stripe.com/v3/"></script>
                        <script src={`https://maps.googleapis.com/maps/api/js?key=${Project.maps}&libraries=places`}></script>
                    </Head>
                    <Component {...pageProps} />
                    <div id="confirm"/>
                    <div id="alert"/>
                    {
                            E2E && (
                                <React.Fragment>
                                    <div className="e2e" id="e2e-request" />
                                    <div className="e2e" id="e2e-error" />
                                </React.Fragment>
                            )
                        }
                    <script type="module" src="https://unpkg.com/ionicons@5.0.0/dist/ionicons/ionicons.esm.js"></script>
                    <script noModule="" src="https://unpkg.com/ionicons@5.0.0/dist/ionicons/ionicons.js"></script>
                </React.Fragment>
            </Provider>
        );
    }
}

export default withRedux(createStore)(withAuth(withReduxSaga(MyApp)));
